import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import mobileMenu from "../medias/mobileMenu.png";
import { IoIosCloseCircleOutline } from 'react-icons/io';


const MoblieHeader = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isResourcesOpen, setIsResourcesOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    
    const paths = [
        { name: "Demo", link: "/#demo", isHash: true },
        { name: "How it Works", link: "/#how-it-works", isHash: true },
        { name: "Features", link: "/#features", isHash: true },
        { name: "Pricing", link: "/#pricing", isHash: true },
        { name: "Login", link: "https://customsync.app/login", isHash: false },
        { name: "Sign up", link: "https://customsync.app/login?signup=true", isHash: false },
    ];

    const openBurgerMenu = () => {
        setIsOpen(true);
    };

    const closeBurgerMenu = () => {
        setIsOpen(false);
        setIsResourcesOpen(false);
    };

    const handleHashNavigation = (hash) => {
        closeBurgerMenu(); // Close mobile menu first
        if (location.pathname === '/') {
            // We're already on home page, just scroll to the section
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } else {
            // We're on a different page, navigate to home first, then scroll
            navigate('/');
            // Use setTimeout to ensure the page has loaded before scrolling
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        }
    };

    useEffect(() => {
        const links = document.querySelectorAll(".link");
        links.forEach((link, index) => {
            link.style.transitionDelay = `${index * 100}ms`;
        });
    }, [isOpen]);
    
    return (
        <div>
            <img onClick={isOpen ? closeBurgerMenu : openBurgerMenu} className='md:hidden block cursor-pointer' src={mobileMenu} alt="" />
            <div
                id="dropdown"
                className={`fixed top-0 right-0 bg-gradient-to-b from-[#19344D] to-[#3B79B3] text-white max-w-96 w-full z-50 h-full transform transition-all duration-500 ease-in-out ${isOpen ? "translate-x-0" : "translate-x-full"
                    }`}
            >
                <div className="mb-4 px-6 pt-6 flex items-center justify-between">
                    <h2 className="opacity-60 text-[16px] uppercase">Navigation</h2>
                    <button
                        className='text-[35px]'
                        onClick={closeBurgerMenu}
                    >
                        <IoIosCloseCircleOutline />
                    </button>
                </div>

                <div className="h-[1px] w-full bg-gray-500 mt-4"></div>
                <div className="px-6" id="links">
                    {paths.map((path, index) => (
                        path.isHash ? (
                            <button
                                key={path.name}
                                onClick={() => handleHashNavigation(path.link.replace('/', ''))}
                                className={`py-4 text-2xl block transition-transform duration-500 ease-in-out link font-bold transform ${isOpen ? "translate-x-0" : "translate-x-full"
                                    }`}
                                style={{ transitionDelay: `${index * 100}ms` }}
                            >
                                {path.name}
                            </button>
                        ) : (
                            path.link.startsWith('http') ? (
                                <a
                                    key={path.name}
                                    href={path.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`py-4 text-2xl block transition-transform duration-500 ease-in-out link font-bold transform ${isOpen ? "translate-x-0" : "translate-x-full"
                                        }`}
                                    style={{ transitionDelay: `${index * 100}ms` }}
                                >
                                    {path.name}
                                </a>
                            ) : (
                                <Link
                                    key={path.name}
                                    to={path.link}
                                    className={`py-4 text-2xl block transition-transform duration-500 ease-in-out link font-bold transform ${isOpen ? "translate-x-0" : "translate-x-full"
                                        }`}
                                    style={{ transitionDelay: `${index * 100}ms` }}
                                >
                                    {path.name}
                                </Link>
                            )
                        )
                    ))}
                    
                    {/* Resources Section */}
                    <div className="py-4">
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsResourcesOpen(!isResourcesOpen);
                            }}
                            className="text-2xl font-bold flex items-center justify-between w-full"
                        >
                            Resources
                            <svg 
                                className={`w-6 h-6 transition-transform duration-200 ${isResourcesOpen ? 'rotate-180' : ''}`} 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        
                        <div className={`mt-2 ml-4 space-y-2 transition-all duration-200 ${isResourcesOpen ? 'opacity-100 max-h-32' : 'opacity-0 max-h-0 overflow-hidden'}`}>
                            <Link
                                to="/blog"
                                className="block py-2 text-xl text-gray-200 hover:text-white transition-colors"
                            >
                                Blog
                            </Link>
                            <a
                                style={{display: 'none'}}
                                href="https://discord.gg/customsync"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block py-2 text-xl text-gray-200 hover:text-white transition-colors"
                            >
                                Discord Group
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MoblieHeader;